import React, { FC } from 'react';
import imgURL from '../../../../lib/imgURL';
import Modal from '../../../Modal';
import Button from '../../../Button';
import Props from './typing';
import './styles.scss';

const RenderModalBody: FC<Props> = (props): JSX.Element => {
  return (
    <div>
      <div className='discover-slide'>
        <div className='discover-content'>
          <div className='discover-title'>Discover whats new.</div>
          <div className='discover-description'>
            Let&apos;s start with a quick product tour!
          </div>
          <div className='discover-buttons'>
            <Button
              btnStyleClass='dis-primary marginRight'
              label="Let's Go"
              enable
              onClick={() => props?.setCurrentStep(props?.currentStep + 1)}
            />
            <Button
              btnStyleClass='dis-linkBtn'
              label='Skip for Now'
              enable
              onClick={() => props?.closeModal()}
            />
          </div>
        </div>
        <div className='discover-img'>
          <img src={imgURL['happy-news-new']} alt='happy-news' />
        </div>
      </div>
    </div>
  );
};

const WhatsNewModal: FC<Props> = (props): JSX.Element => {
  return (
    <Modal
      ModalBody={RenderModalBody}
      modalWrapperClass={'whats-new-modal'}
      modalBodyProps={{ ...props }}
    />
  );
};

export default WhatsNewModal;
